var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "dialog" }
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-xl", attrs: { role: "document" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _vm.isMaintenance
                ? _c(
                    "h4",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "myModalLabel" }
                    },
                    [
                      _vm.cell && _vm.cell.id
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("txtCellEdit")) +
                                "\n          "
                            )
                          ]
                        : [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("txtCellAdd")) +
                                "\n          "
                            )
                          ]
                    ],
                    2
                  )
                : _c(
                    "h4",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "myModalLabel" }
                    },
                    [_vm._v(_vm._s(_vm.$t("txtObjectAdd")))]
                  )
            ]),
            _vm._v(" "),
            _vm.cell
              ? _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "div",
                    {
                      staticClass: "btn-group w-100",
                      staticStyle: { "flex-wrap": "wrap" }
                    },
                    [
                      _c(
                        "TabButton",
                        {
                          attrs: { tab: "general" },
                          model: {
                            value: _vm.tab,
                            callback: function($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab"
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-boxes" }),
                          _vm._v(_vm._s(_vm.$t("cellTabGeneral")))
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "TabButton",
                        {
                          attrs: { tab: "cost" },
                          model: {
                            value: _vm.tab,
                            callback: function($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab"
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-euro-sign" }),
                          _vm._v(_vm._s(_vm.$t("cellTabCost")))
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "TabButton",
                        {
                          attrs: { tab: "attachments" },
                          model: {
                            value: _vm.tab,
                            callback: function($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab"
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-paperclip" }),
                          _vm._v(_vm._s(_vm.$t("cellTabAttachments")))
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "TabButton",
                        {
                          attrs: { tab: "history" },
                          model: {
                            value: _vm.tab,
                            callback: function($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab"
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-clock" }),
                          _vm._v(_vm._s(_vm.$t("cellTabHistory")))
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "TabButton",
                        {
                          attrs: { tab: "duties" },
                          model: {
                            value: _vm.tab,
                            callback: function($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab"
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-calendar-plus" }),
                          _vm._v(_vm._s(_vm.$t("cellTabDuties")))
                        ]
                      ),
                      _vm._v(" "),
                      _vm.canMap
                        ? _c(
                            "TabButton",
                            {
                              attrs: { tab: "coords" },
                              model: {
                                value: _vm.tab,
                                callback: function($$v) {
                                  _vm.tab = $$v
                                },
                                expression: "tab"
                              }
                            },
                            [
                              _c("i", { staticClass: "fa fa-map-marker-alt" }),
                              _vm._v(_vm._s(_vm.$t("cellTabCoords")))
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.canMap
                        ? _c(
                            "TabButton",
                            {
                              attrs: { tab: "inventories" },
                              model: {
                                value: _vm.tab,
                                callback: function($$v) {
                                  _vm.tab = $$v
                                },
                                expression: "tab"
                              }
                            },
                            [
                              _c("i", { staticClass: "fa fa-th-large" }),
                              _vm._v(_vm._s(_vm.$t("cellTabInventories")))
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.canOee
                        ? _c(
                            "TabButton",
                            {
                              attrs: { tab: "oee" },
                              model: {
                                value: _vm.tab,
                                callback: function($$v) {
                                  _vm.tab = $$v
                                },
                                expression: "tab"
                              }
                            },
                            [
                              _c("i", { staticClass: "fa fa-stopwatch" }),
                              _vm._v(_vm._s(_vm.$t("cellTabOee")))
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.canDemo
                        ? _c(
                            "TabButton",
                            {
                              attrs: { tab: "meter" },
                              model: {
                                value: _vm.tab,
                                callback: function($$v) {
                                  _vm.tab = $$v
                                },
                                expression: "tab"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-thermometer-half"
                              }),
                              _vm._v(_vm._s(_vm.$t("cellTabMeters")))
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "TabButton",
                        {
                          attrs: { tab: "misc" },
                          model: {
                            value: _vm.tab,
                            callback: function($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab"
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-palette" }),
                          _vm._v(_vm._s(_vm.$t("cellTabMisc")))
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tab === "general",
                          expression: "tab === 'general'"
                        }
                      ]
                    },
                    [
                      _c("TabGeneral", {
                        attrs: {
                          lines: _vm.lines,
                          cells: _vm.cells,
                          cell: _vm.cell
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tab === "cost",
                          expression: "tab === 'cost'"
                        }
                      ]
                    },
                    [
                      _c("TabCost", {
                        attrs: {
                          cell: _vm.cell,
                          correctionCosts: _vm.correctionCosts,
                          plannedCosts: _vm.plannedCosts,
                          unplannedCosts: _vm.unplannedCosts
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tab === "attachments",
                          expression: "tab === 'attachments'"
                        }
                      ]
                    },
                    [
                      _vm.isAiEnabled
                        ? _c("div", { staticClass: "form-group form-check" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.aiActiveForUploads,
                                  expression: "aiActiveForUploads"
                                }
                              ],
                              staticClass: "form-check-input",
                              staticStyle: { "margin-left": "-1rem" },
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.aiActiveForUploads)
                                  ? _vm._i(_vm.aiActiveForUploads, null) > -1
                                  : _vm.aiActiveForUploads
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.aiActiveForUploads,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.aiActiveForUploads = $$a.concat([
                                          $$v
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.aiActiveForUploads = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.aiActiveForUploads = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(
                              _vm._s(_vm.$t("ai.activeForUploads")) +
                                "\n          "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("ImageViewer", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.cell &&
                              _vm.cell.files &&
                              _vm.cell.files.length,
                            expression:
                              "cell && cell.files && cell.files.length"
                          }
                        ],
                        attrs: {
                          isShowDelete: _vm.canMediaDelete,
                          medias: _vm.cell ? _vm.cell.files : []
                        },
                        on: {
                          "removed-media": function($event) {
                            _vm.$toasted.info(_vm.$t("txtDeleted").toString())
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("DropZone", {
                        attrs: { formId: "celleditdz" },
                        on: { complete: _vm.onDzComplete }
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary w-100",
                          on: { click: _vm.openMediaPicker }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("cellSelectMedia")) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("MediaPicker", {
                        ref: "mediapicker",
                        on: { selected: _vm.onMediaPickerSelected }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tab === "history",
                          expression: "tab === 'history'"
                        }
                      ]
                    },
                    [
                      _c("VueGoodTable", {
                        attrs: {
                          columns: _vm.columnsConfig,
                          rows: _vm.lastActivities
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tab === "coords",
                          expression: "tab === 'coords'"
                        }
                      ]
                    },
                    [
                      _c("table", [
                        _c(
                          "tr",
                          [
                            _vm.cell
                              ? [
                                  _c("td", [
                                    _c("div", [
                                      _vm._v(_vm._s(_vm.$t("cellAddress")))
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.cell.address,
                                          expression: "cell.address"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: { type: "text" },
                                      domProps: { value: _vm.cell.address },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.cell,
                                            "address",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("div", [
                                      _vm._v(_vm._s(_vm.$t("cellZIP")))
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.cell.zip,
                                          expression: "cell.zip"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: { type: "text" },
                                      domProps: { value: _vm.cell.zip },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.cell,
                                            "zip",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("div", [
                                      _vm._v(_vm._s(_vm.$t("cellCity")))
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.cell.city,
                                          expression: "cell.city"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: { type: "text" },
                                      domProps: { value: _vm.cell.city },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.cell,
                                            "city",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("div", [
                                      _vm._v(_vm._s(_vm.$t("cellCountry")))
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.cell.country,
                                          expression: "cell.country"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: { type: "text" },
                                      domProps: { value: _vm.cell.country },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.cell,
                                            "country",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ])
                                ]
                              : _vm._e()
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("txtCoordLatitude") + ":"))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.coords && _vm.coords.lat))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("txtCoordLongitude") + ":"))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.coords && _vm.coords.lng))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.coords
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary",
                              on: { click: _vm.copyCoordsToClipboard }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("txtCopy")) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tab === "inventories",
                          expression: "tab === 'inventories'"
                        }
                      ]
                    },
                    [
                      _c("TabInventory", {
                        attrs: { cell: _vm.cell, inventories: _vm.inventories }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tab === "duties",
                          expression: "tab === 'duties'"
                        }
                      ]
                    },
                    [_c("TabDuties", { attrs: { cell: _vm.cell } })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tab === "oee",
                          expression: "tab === 'oee'"
                        }
                      ]
                    },
                    [_c("OeeTab", { attrs: { cell: _vm.cell } })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tab === "meter",
                          expression: "tab === 'meter'"
                        }
                      ]
                    },
                    [_c("MeterTab", { attrs: { cell: _vm.cell } })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tab === "misc",
                          expression: "tab === 'misc'"
                        }
                      ]
                    },
                    [_c("MiscTab", { attrs: { cell: _vm.cell } })],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _vm.tab === "history"
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.gotoAudit }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("cellGoToAudit")) +
                          "\n        "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button" },
                  on: { click: _vm.dismiss }
                },
                [_vm._v(_vm._s(_vm.$t("btnClose")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "visible",
                      rawName: "v-visible",
                      value: _vm.tab === "general",
                      expression: "tab === 'general'"
                    }
                  ],
                  staticClass: "btn btn-primary",
                  attrs: { type: "button", disabled: !_vm.canSave },
                  on: { click: _vm.save }
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("btnSave")) + "\n        "
                  )
                ]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }